import script from "./min_title_text.vue?vue&type=script&setup=true&lang=js"
export * from "./min_title_text.vue?vue&type=script&setup=true&lang=js"

import "./min_title_text.vue?vue&type=style&index=0&id=c80d9138&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c80d9138"]])

export default __exports__